import erreurChampsVide from '@/services/validation/erreurChampsVide';

export default function validation(response, responseMessage, champsVide,
  messages, messagesChampsVide) {
  if (responseMessage === 'MOT_PASSE_DIFFERENT') {
    messages.push({
      message: 'validationUtilisateur.confMotPasse',
    });
    return;
  }
  if (response && response.data.error && response.data.error.message
    && (response.data.error.message.indexOf('Le nom') === 0
    || response.data.error.message.indexOf('User name') === 0)) {
    messages.push({
      message: 'validationUtilisateur.userAlreadyTake',
    });
  }
  if (response && response.data.error && response.data.error.message
    && (response.data.error.message.indexOf('L\'email') === 0
    || response.data.error.message.indexOf('Email') === 0)) {
    messages.push({
      message: 'validationUtilisateur.emailAlreadyTake',
    });
  }
  if (!response.data.error || !response.data.error.validationErrors) {
    return;
  }

  response.data.error.validationErrors.forEach((error) => {
    const champs = 0;
    const message = error.message;
    if (!message) {
      erreurChampsVide(champsVide, champs, messagesChampsVide);
    }
    if (message.indexOf('The Nom field is required') === 0) {
      messages.push({
        message: 'validationUtilisateur.nom',
      });
    }
    if (message.indexOf('Utilisateur_RegieExterneMusteHaveCommercialRole') === 0) {
      messages.push({
        message: 'validationUtilisateur.regieExterneMusBeCommercial',
      });
    }
    if (message.indexOf('PASSWORD') === 0) {
      messages.push({
        message: 'validationUtilisateur.motPasseLength',
      });
    }
    if (message.indexOf('The MotPasse field is required') === 0) {
      messages.push({
        message: 'validationUtilisateur.motPasse',
      });
    }
    if (message.indexOf('SHOULD_HAVE_A_ROLE') === 0) {
      messages.push({
        message: 'validationUtilisateur.role',
      });
    }
    if (message.indexOf('The AgenceId field is required') === 0) {
      messages.push({
        message: 'validationUtilisateur.agence',
      });
    }
    if (message.indexOf('DEFAULT_AGENCY_SHOULD_BE_SELECTED') === 0) {
      messages.push({
        message: 'validationUtilisateur.agenceRattachementSelect',
      });
    }
    if (message.indexOf('CANNOT_CONTAINS@Identifiant@') === 0) {
      messages.push({
        message: 'validationUtilisateur.identifiantWithArobase',
      });
    }
    if (message.indexOf('EMAIL') === 0) {
      messages.push({
        message: 'validationUtilisateur.emailNotValid',
      });
    }
    if (message.indexOf('ENUM') === 0) {
      messages.push({
        message: 'validationUtilisateur.profil',
      });
    }
    if (message.indexOf('UTILISATEUR_PASSWORD_CONTAINS_FORBIDDEN_CHARACTERS') === 0) {
      messages.push({
        message: 'validationUtilisateur.passwordNotValid',
      });
    }
    if (message.indexOf('TIER_ALREADY_USE_IN_AN_ELEMENT') === 0) {
      messages.push({
        message: 'validationUtilisateur.utiliseDansAffixe',
      });
    }
  });
}
